import { Fragment, h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import { getHTML } from '../../base/domManager';
import { DATA_EVENTS, EVENTS, INTERNAL_EVENTS, SDK_EVENTS } from '../../../constants/events.cnst';
import { ClassMapConstanst, DARKTHEME_COLORCODES, IdMapConstant, ProjConstants, storageConst, Tabs } from '../../../constants/projConsts';
import { ActiveOrPassive } from '../../../../../hooks/ActiveOrPassive';
import { RenderEmptyAssistScreen } from '../assist/assist';
import './agentic-CoPilot.scss';
import { addScrollButtons } from '../../../utils/scrollUtils';
import { marked } from 'marked';
import { DynamicSendActionBtn, initializeProgressOnButton } from '../atom/dynamic-send-action-btn';
import fetchInstance from '../../../utils/interceptor';
import { ERROR_CODES } from '../../../constants/errorcodes';
import RandomuuidPipe from '../../../utils/randomuuid';


export function RenderEmptyAgenticCoPilotScreen(props: any) {
    const languageData = props?.hostInstance?.languagedata
    return (
            <div className="empty-listing-triggers aa-assist-empty aa-assist-empty-agentic assist-empty-agentic">
                <h1 className="aa-text-sm medium">{languageData?.TRIGGER_LISTEN}</h1>
                <p className="aa-desc-xs center">{languageData?.AGENTIC_COPILOT_DESC}</p>
            </div>
    )
}

export function RenderAgenticOverrideInput(props:any){
    const languageData = props?.hostInstance?.languagedata;
    return (
        <div className={`aa-agentic-override-input-wrapper-${props?.msgData?.positionId} a-radius-8  aa-input-fixed-text-block a-flex a-gap-4 a-align-items-center a-width-100 a-padding-sm-top a-padding-sm-bottom a-padding-md-left a-padding-md-right input-wrapper`}>
            <span className="a-flex-shrink-0 aa-text-xs medium">{props?.msgData?.author === 'USER' ? `${languageData?.CUSTOMER}` : `${languageData?.AGENTIC_AGENT_TITLE}`}:</span>
            <input type="text" placeholder="Type here..." className="aa-agentic-override-text a-width-100 aa-text-xs medium" />
            <button className="input-text-btn aa-input-override-cancel-btn a-flex a-align-items-center a-justify-content-center cursor-pointer a-flex-shrink-0 a-padding-xs">
            <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
            <path d="M11.7071 1.70711C12.0976 1.31658 12.0976 0.683417 11.7071 0.292893C11.3166 -0.0976311 10.6834 -0.0976311 10.2929 0.292893L6 4.58579L1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L4.58579 6L0.292893 10.2929C-0.0976311 10.6834 -0.0976311 11.3166 0.292893 11.7071C0.683417 12.0976 1.31658 12.0976 1.70711 11.7071L6 7.41421L10.2929 11.7071C10.6834 12.0976 11.3166 12.0976 11.7071 11.7071C12.0976 11.3166 12.0976 10.6834 11.7071 10.2929L7.41421 6L11.7071 1.70711Z" fill="#98A2B3"/>
            </svg>
            </button>
            <button className="input-text-btn aa-input-override-submit-btn a-flex a-align-items-center a-justify-content-center cursor-pointer a-flex-shrink-0 a-padding-xs">
            <svg width="12" height="12" viewBox="0 0 18 13" fill="none">
                <path d="M17 1L6 12L1 7" stroke="var(--AA-global-theme-text-color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            </button>
        </div>
    )
}

export function agenticCoPilotNodeHeaderSection(props:any){
    const languageData = props?.hostInstance?.languagedata;
    
    return (
        <>
        <div className={`aa-agentic-copilot-node-wrapper aa-agentic-node-wrapper-${props?.msgData?.positionId}`}>
        <div className={`aa-agentic-copilot-node a-flex a-flex-column a-gap-8  aa-agentic-node-${props?.msgData?.positionId}`}>
            <div className={`agentic-copilot-node-header aa-agentic-interrupt-header-${props?.msgData?.positionId}`}>
               
                    <div className="agentic-node-icon a-flex a-align-items-center a-justify-content-center a-radius-999 a-flex-shrink-0">
                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                    <path d="M1.86874 12.0636L1.56951 12.6575L1.86874 12.0636ZM0.904539 11.1101L1.49568 10.8055L0.904539 11.1101ZM12.0599 1.85642L11.4688 2.16101L12.0599 1.85642ZM8.77029 0.665128L8.77029 1.33013L8.77028 1.33013L8.77029 0.665128ZM11.0957 0.902932L11.395 0.309058L11.0957 0.902932ZM4.1942 0.665039L4.1942 3.89989e-05L4.19421 3.89989e-05L4.1942 0.665039ZM1.86874 0.902843L1.56951 0.30897L1.86874 0.902843ZM0.904538 1.85633L1.49568 2.16092L0.904538 1.85633ZM7.14724 5.39231L7.14724 6.05731L5.81724 6.05731L5.81724 5.39231L7.14724 5.39231ZM5.81724 3.57413L5.81724 2.90913L7.14724 2.90913L7.14724 3.57413L5.81724 3.57413ZM4.60179 6.48331L4.60179 7.14831L3.27179 7.14831L3.27179 6.48331L4.60179 6.48331ZM3.27179 3.57413L3.27179 2.90913L4.60179 2.90913L4.60179 3.57413L3.27179 3.57413ZM12.9654 5.39231L12.9654 6.05731L11.6354 6.05731L11.6354 5.39231L12.9654 5.39231ZM5.75497 11.6364L6.41997 11.6364L6.41997 12.9664L5.75497 12.9664L5.75497 11.6364ZM8.1256 8.14351L8.75865 8.34718C8.69316 8.55071 8.53382 8.71033 8.33042 8.77618L8.1256 8.14351ZM5.39134 9.02868L5.18652 9.66135L5.18652 8.396L5.39134 9.02868ZM8.1256 9.91384L8.33042 9.28117C8.53383 9.34702 8.69316 9.50665 8.75865 9.71017L8.1256 9.91384ZM9.01077 12.665L9.64381 12.8687L8.37773 12.8687L9.01077 12.665ZM9.89594 9.91384L9.2629 9.71017C9.32864 9.50584 9.48895 9.34581 9.69339 9.28044L9.89594 9.91384ZM12.6641 9.02867L12.8666 8.39527L12.8666 9.66208L12.6641 9.02867ZM9.89594 8.14351L9.69339 8.77691C9.48895 8.71154 9.32864 8.55151 9.2629 8.34718L9.89594 8.14351ZM9.01077 5.39231L8.37773 5.18864L9.64381 5.18864L9.01077 5.39231ZM8.77029 0.665128L8.77028 1.33013L4.19418 1.33004L4.1942 0.665039L4.19421 3.89989e-05L8.77031 0.000127696L8.77029 0.665128ZM0.664063 4.15595L1.32906 4.15595L1.32906 8.81049L0.664063 8.81049L-0.000937424 8.81049L-0.00093748 4.15595L0.664063 4.15595ZM4.1942 12.3014L4.1942 12.9664C3.58722 12.9664 3.09243 12.9669 2.69153 12.9345C2.28307 12.9015 1.9142 12.8312 1.56951 12.6575L1.86874 12.0636L2.16797 11.4697C2.29524 11.5339 2.47127 11.5824 2.79863 11.6088C3.13355 11.6359 3.56551 11.6364 4.1942 11.6364L4.1942 12.3014ZM0.664063 8.81049L1.32906 8.81049C1.32906 9.43256 1.32959 9.85866 1.35686 10.1888C1.38348 10.5109 1.43213 10.6822 1.49568 10.8055L0.904539 11.1101L0.313394 11.4147C0.136467 11.0713 0.0648864 10.7038 0.0313803 10.2983C-0.00146616 9.90071 -0.000937417 9.41037 -0.000937424 8.81049L0.664063 8.81049ZM1.86874 12.0636L1.56951 12.6575C1.02984 12.3856 0.589697 11.9509 0.313394 11.4147L0.904539 11.1101L1.49568 10.8055C1.64244 11.0903 1.87734 11.3233 2.16797 11.4697L1.86874 12.0636ZM12.3004 4.15604L11.6354 4.15604C11.6354 3.53398 11.6349 3.10787 11.6076 2.77778C11.581 2.45567 11.5324 2.28434 11.4688 2.16101L12.0599 1.85642L12.6511 1.55183C12.828 1.89522 12.8996 2.26273 12.9331 2.66827C12.966 3.06582 12.9654 3.55617 12.9654 4.15604L12.3004 4.15604ZM8.77029 0.665128L8.77029 0.000127696C9.37727 0.000127688 9.87206 -0.000378122 10.273 0.0320132C10.6814 0.0650142 11.0503 0.13538 11.395 0.309058L11.0957 0.902932L10.7965 1.49681C10.6692 1.43268 10.4932 1.38414 10.1659 1.35769C9.83094 1.33063 9.39898 1.33013 8.77029 1.33013L8.77029 0.665128ZM12.0599 1.85642L11.4688 2.16101C11.3221 1.87619 11.0871 1.64324 10.7965 1.49681L11.0957 0.902932L11.395 0.309058C11.9346 0.580977 12.3748 1.01559 12.6511 1.55183L12.0599 1.85642ZM4.1942 0.665039L4.1942 1.33004C3.56551 1.33004 3.13355 1.33054 2.79863 1.3576C2.47127 1.38405 2.29524 1.43259 2.16797 1.49672L1.86874 0.902843L1.56951 0.30897C1.9142 0.135292 2.28307 0.0649256 2.69153 0.0319245C3.09243 -0.000466793 3.58722 3.90062e-05 4.1942 3.89989e-05L4.1942 0.665039ZM0.664063 4.15595L-0.00093748 4.15595C-0.000937487 3.55608 -0.00146625 3.06573 0.0313802 2.66818C0.0648863 2.26264 0.136466 1.89513 0.313394 1.55175L0.904538 1.85633L1.49568 2.16092C1.43213 2.28425 1.38348 2.45558 1.35686 2.77769C1.32959 3.10778 1.32906 3.53389 1.32906 4.15595L0.664063 4.15595ZM1.86874 0.902843L2.16797 1.49672C1.87734 1.64315 1.64244 1.8761 1.49568 2.16092L0.904538 1.85633L0.313394 1.55175C0.589697 1.0155 1.02984 0.580888 1.56951 0.30897L1.86874 0.902843ZM6.48224 5.39231L5.81724 5.39231L5.81724 3.57413L6.48224 3.57413L7.14724 3.57413L7.14724 5.39231L6.48224 5.39231ZM3.93679 6.48331L3.27179 6.48331L3.27179 3.57413L3.93679 3.57413L4.60179 3.57413L4.60179 6.48331L3.93679 6.48331ZM12.3004 5.39231L11.6354 5.39231L11.6354 4.15604L12.3004 4.15604L12.9654 4.15604L12.9654 5.39231L12.3004 5.39231ZM4.1942 12.3014L4.1942 11.6364L5.75497 11.6364L5.75497 12.3014L5.75497 12.9664L4.1942 12.9664L4.1942 12.3014ZM8.1256 8.14351L8.33042 8.77618L5.59615 9.66135L5.39134 9.02868L5.18652 8.396L7.92079 7.51084L8.1256 8.14351ZM5.39134 9.02868L5.59615 8.396L8.33042 9.28117L8.1256 9.91384L7.92079 10.5465L5.18652 9.66135L5.39134 9.02868ZM8.1256 9.91384L8.75865 9.71017L9.64381 12.4614L9.01077 12.665L8.37773 12.8687L7.49256 10.1175L8.1256 9.91384ZM9.01077 12.665L8.37773 12.4614L9.2629 9.71017L9.89594 9.91384L10.529 10.1175L9.64381 12.8687L9.01077 12.665ZM9.89594 9.91384L9.69339 9.28044L12.4615 8.39527L12.6641 9.02867L12.8666 9.66208L10.0985 10.5472L9.89594 9.91384ZM12.6641 9.02867L12.4615 9.66208L9.69339 8.77691L9.89594 8.14351L10.0985 7.5101L12.8666 8.39527L12.6641 9.02867ZM9.89594 8.14351L9.2629 8.34718L8.37773 5.59599L9.01077 5.39231L9.64381 5.18864L10.529 7.93983L9.89594 8.14351ZM9.01077 5.39231L9.64381 5.59599L8.75865 8.34718L8.1256 8.14351L7.49256 7.93983L8.37773 5.18864L9.01077 5.39231Z" fill="#155EEF"/>
                    </svg>
                    </div>
                   <div className={`agentic-node-query-title a-width-100 a-overflow-hidden aa-agentic-cust-info-${props?.msgData?.positionId}`}>
                     <div className={`cust-info-section aa-text-xs text-truncate`}><span className={`aa-desc-xs medium`}>{props?.msgData?.author === 'USER' ? `${languageData?.CUSTOMER}` : `${languageData?.AGENTIC_AGENT_TITLE}`} :</span> {props?.msgData?.reqMsg}</div>
                   </div>
                   <div className={`agentic-node-regenerate-input-wrapper aa-hidden a-width-100 a-position-relative aa-agentic-node-regenerate-input-wrapper-${props?.msgData?.positionId}`}>
                     <input type="text" value={props?.msgData?.reqMsg} className="regenerate-input aa-agentic-node-regenerate-input a-radius-8 a-width-100 a-padding-md-left a-padding-md-right a-padding-sm-bottom a-padding-sm-top aa-text-xs medium" />
                     <div className={`a-flex a-align-items-center a-position-absolute regenerate-copy-cancel`}>
                     <button className="input-text-btn cancel-button aa-regenerate-cancel-btn a-flex a-align-items-center a-justify-content-center cursor-pointer a-flex-shrink-0 a-padding-xs">
                        <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                        <path d="M11.7071 1.70711C12.0976 1.31658 12.0976 0.683417 11.7071 0.292893C11.3166 -0.0976311 10.6834 -0.0976311 10.2929 0.292893L6 4.58579L1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L4.58579 6L0.292893 10.2929C-0.0976311 10.6834 -0.0976311 11.3166 0.292893 11.7071C0.683417 12.0976 1.31658 12.0976 1.70711 11.7071L6 7.41421L10.2929 11.7071C10.6834 12.0976 11.3166 12.0976 11.7071 11.7071C12.0976 11.3166 12.0976 10.6834 11.7071 10.2929L7.41421 6L11.7071 1.70711Z" fill="#98A2B3"/>
                        </svg>
                        </button>
                        <button className="input-text-btn submit-button aa-regenerate-submit-btn a-flex a-align-items-center a-justify-content-center cursor-pointer a-flex-shrink-0 a-padding-xs">
                        <svg width="12" height="12" viewBox="0 0 18 13" fill="none">
                            <path d="M17 1L6 12L1 7" stroke="var(--AA-global-theme-text-color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                     </button>
                     </div>
                   </div>
              
            </div>
        </div>

        </div>
        
         
        </>       
    )
}

export function agenticCoPilotMessageSection(props:any){
    const languageData = props?.hostInstance?.languagedata;
    return (
            <div className={`aa-agentic-copilot-node-body-wrapper a-flex a-flex-column a-gap-8 aa-agentic-node-body-wrapper-${props?.msgData?.positionId}`}>
                <div className={`aa-agentic-copilot-node-body aa-hidden a-position-relative a-width-100 cursor-pointer a-radius-12 a-padding-sm-top a-padding-sm-bottom a-padding-smm-left a-padding-smm-right aa-agentic-interrupt-body-${props?.msgData?.positionId}`}>
                    <div className="agentic-send-or-copy-actions aa-agentic-send-or-copy-actions a-position-absolute a-radius-4 a-flex a-gap-4 a-align-items-center">
                        <button className="aa-agentic-copy-btn aa-solidbtn a-radius-4 aa-text-xxs medium" aria-label="Copy">
                            <svg  width="10" height="10" viewBox="0 0 11 11" fill="none">
                             <path d="M7.5 7.5V8.9C7.5 9.46005 7.5 9.74008 7.39101 9.95399C7.29513 10.1422 7.14215 10.2951 6.95399 10.391C6.74008 10.5 6.46005 10.5 5.9 10.5H2.1C1.53995 10.5 1.25992 10.5 1.04601 10.391C0.857847 10.2951 0.704867 10.1422 0.608993 9.95399C0.5 9.74008 0.5 9.46005 0.5 8.9V5.1C0.5 4.53995 0.5 4.25992 0.608993 4.04601C0.704867 3.85785 0.857847 3.70487 1.04601 3.60899C1.25992 3.5 1.53995 3.5 2.1 3.5H3.5M5.1 7.5H8.9C9.46005 7.5 9.74008 7.5 9.95399 7.39101C10.1422 7.29513 10.2951 7.14215 10.391 6.95399C10.5 6.74008 10.5 6.46005 10.5 5.9V2.1C10.5 1.53995 10.5 1.25992 10.391 1.04601C10.2951 0.857847 10.1422 0.704867 9.95399 0.608993C9.74008 0.5 9.46005 0.5 8.9 0.5H5.1C4.53995 0.5 4.25992 0.5 4.04601 0.608993C3.85785 0.704867 3.70487 0.857847 3.60899 1.04601C3.5 1.25992 3.5 1.53995 3.5 2.1V5.9C3.5 6.46005 3.5 6.74008 3.60899 6.95399C3.70487 7.14215 3.85785 7.29513 4.04601 7.39101C4.25992 7.5 4.53995 7.5 5.1 7.5Z" stroke="#101828" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                        <button className="aa-agentic-sent-btn aa-solidbtn a-radius-4 aa-text-xxs medium" aria-label="Send">
                            {languageData?.SEND}
                        </button>
                    </div>
                    <div className="agentic-send-or-copy-actions aa-agentic-sent-copy-action aa-action-text a-position-absolute a-radius-4 a-flex a-gap-4 a-align-items-center aa-text-xxs medium aa-text-primary aa-hidden">sent</div>
                    <div className="aa-agentic-send-dyn-btn a-position-absolute a-radius-999">

                    </div>
                    <div className="aa-agentic-node-answer aa-text-xxs medium">

                    </div>
                </div>
                <div className={`aa_btn primaryBtn a-width-100 cursor-pointer aa-hidden aa-agentic-interrupt-override-${props?.msgData?.positionId}`}>
                    {languageData?.OVERRIDE_BTN}
                </div>
                <div className={`agentic-node-thinking-section a-flex a-align-items-center aa-desc-xs a-padding-md-left a-gap-6 aa-agentic-thinking-msg-${props?.msgData?.positionId}`}>
                    {languageData?.AGENTIC_THINKING}
                    <div className="agentic-node-thinking-text">
                        <div class="call-connecting-progress-wave a-flex a-align-items-center justify-content-center a-gap-4">
                            <span class="call-connecting-dot a-radius-999"></span>
                            <span class="call-connecting-dot a-radius-999"></span>
                            <span class="call-connecting-dot a-radius-999"></span>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export const AgenticCoPilot = ({hostInstance} : any) => {

    const rootServiceInstance = hostInstance.rootService;
    const classConstants = ClassMapConstanst;

    const agenticNodeArray: any[] = rootServiceInstance?.agenticNodeArray;


    const [agenticStartEnabled, setAgenticStartEnabled] = useState(false);
    const [agenticPilotArr, setAgenticPilotArr] = useState<any[]>([]);
    const [isAutoSendEnabled, setIsAutoSendEnabled] = useState(true);
    const [isPaused, setIsPaused] = useState(false);
    const isInitCopilotRef = useRef<boolean>(false);
    const isHeaderAddedRef = useRef<boolean>(false);   

    useEffect(() => {
        listenSocketEvents();
        return () => {
            unListenSocketEvents();
        }
    }, []);

    useEffect(() => {
        rootServiceInstance.isAgenticAutoSendEnabled = rootServiceInstance?.aaSettings?.[hostInstance?.rootService?.connectionDetails?.channel?.toLowerCase()]?.coPilot?.locale?.[hostInstance?.localStorageService?.getLanguage() || 'en']?.autoSend?.isEnabled || false;
        rootServiceInstance.sendingTimeForAgenticAutoSend = rootServiceInstance?.aaSettings?.[hostInstance?.rootService?.connectionDetails?.channel?.toLowerCase()]?.coPilot?.locale?.[hostInstance?.localStorageService?.getLanguage() || 'en']?.autoSend?.sendAfter * 1000 || 5000;
        setIsAutoSendEnabled((prev:any) => rootServiceInstance.isAgenticAutoSendEnabled);
        if(agenticStartEnabled){
            getCoPilotHistory();
            initializeUI();
        }
    }, [agenticStartEnabled]);

    useEffect(()=>{
        if(isAutoSendEnabled){
            hostInstance?.chatEle?.querySelector(`${classConstants.AGENTIC_PAUSE_AUTO_SEND_BTN}`)?.classList.remove('inactive-auto-send')
        }else{
            hostInstance?.chatEle?.querySelector(`${classConstants.AGENTIC_PAUSE_AUTO_SEND_BTN}`)?.classList?.add('inactive-auto-send')
        }
    },[isAutoSendEnabled])

    useEffect(() => {
        rootServiceInstance.handleAssistScroll(hostInstance);
    }, [agenticPilotArr]);

    useEffect(()=>{
        if(agenticStartEnabled){
            emitAgenticPauseEvent();
            hostInstance.rootService.isAgenticPaused = isPaused;
            if(isPaused){
                hostInstance?.chatEle?.querySelector(`${classConstants.AGENTIC_PLAY_STATE}`)?.classList?.remove('aa-hidden')
                hostInstance?.chatEle?.querySelector(`${classConstants.AGENTIC_PAUSE_STATE}`)?.classList?.add('aa-hidden')
            }else{
                hostInstance?.chatEle?.querySelector(`${classConstants.AGENTIC_PAUSE_STATE}`)?.classList?.remove('aa-hidden')
                hostInstance?.chatEle?.querySelector(`${classConstants.AGENTIC_PLAY_STATE}`)?.classList?.add('aa-hidden')
            }
            overrideCurrentNode();
        }
    }, [isPaused]);

    const overrideCurrentNode = () => {
        if(isPaused){
            hostInstance?.chatEle?.querySelector(`${classConstants.AGENTIC_INTERRUPT_OVERRIDE}${agenticPilotArr.length-1}`)?.classList?.add(classConstants.HIDE_ELEMENT);
            addOverrideInputInAgenticNode(hostInstance?.chatEle?.querySelector(`${classConstants.AGENTIC_NODE_WRAPPER}${agenticPilotArr.length-1}`), agenticPilotArr.length-1);
        }else{
            hostInstance?.chatEle?.querySelector(`${classConstants.AGENTIC_INTERRUPT_OVERRIDE}${agenticPilotArr.length-1}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
            hostInstance?.chatEle?.querySelector(`${classConstants.AGENTIC_NODE_OVERRIDE_INPUT_WRAPPER}${agenticPilotArr.length-1}`)?.classList?.add(classConstants.HIDE_ELEMENT);
        }
    }

    const initializeUI = () => {

        hideAssistClassesInAssistSection();
        // Add empty screen first time only
        if(!isInitCopilotRef.current){
            isInitCopilotRef.current = true;
            addEmptyScreen();
        }
        // Add header once only (protects against duplicate calls)
        if(!isHeaderAddedRef.current){
            addAssistHeader();
        }

        hostInstance?.chatEle?.querySelector(`${classConstants.ASSIST_BLOCK_CONTENT}`)?.classList?.add('highlight-agentic-block-content');
        hostInstance?.chatEle?.querySelector(`${classConstants.AGENTIC_COPILOT_MODE_WRAPPER}`)?.classList?.remove('aa-hidden');
    }

    const addEmptyScreen = () => {

        hideAssistClassesInAssistSection();

        let emptyScreenHtml = getHTML(RenderEmptyAgenticCoPilotScreen, {}, hostInstance);
        hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, emptyScreenHtml, {
            event: SDK_EVENTS.ACP_AGENTIC_EMPTY_TEMPLATE 
        });
        hostInstance?.chatEle?.querySelector(`${classConstants.ASSIST_SECTION}`)?.append(emptyScreenHtml);

    }

    const hideAssistClassesInAssistSection = () => {
        hostInstance?.chatEle?.querySelector(`${classConstants.ASSIST_EMPTY_SCREEN}`)?.classList?.add(classConstants.HIDE_ELEMENT);
    }


    const listenSocketEvents = () => {
        hostInstance.on(INTERNAL_EVENTS.AGENTIC_START, handleAgenticStart);
        hostInstance.on(DATA_EVENTS.AGENTIC_RESPONSE, handleAgenticResponse);
        hostInstance.on(INTERNAL_EVENTS.AGENTIC_END, handleAgenticEnd);
        hostInstance.on(INTERNAL_EVENTS.AGENTIC_REQUEST_ACK, handleAgenticRequestAck);
    }

    const unListenSocketEvents = () => {
        hostInstance.off(INTERNAL_EVENTS.AGENTIC_START, handleAgenticStart);
        hostInstance.off(DATA_EVENTS.AGENTIC_RESPONSE, handleAgenticResponse);
        hostInstance.off(INTERNAL_EVENTS.AGENTIC_END, handleAgenticEnd);
        hostInstance.off(INTERNAL_EVENTS.AGENTIC_REQUEST_ACK, handleAgenticRequestAck);
    }

    const handleAgenticRequestAck = (response : any) => {
        if(response && Object.keys(response).length > 0 && !response?.isSearch){
            if(!isInitCopilotRef.current){
                isInitCopilotRef.current = true;
            }

            if(agenticNodeArray?.find((node:any) => node.requestId === response?.requestId)){
                return;
            }

            const nodeData = {
                reqMsg: response.query,
                author: (response?.type === 'USER' || response?.onConnectTask) ? 'USER' : 'AGENT',
                isThinking: true,
                requestId: response?.requestId,
                msgId : response?.messageId,
                positionId : response?.positionId,
                index : agenticNodeArray.length
            }

            setAgenticPilotArr((prev:any) => [...prev, nodeData]);
            agenticNodeArray.push(nodeData);
            addThinkingAgenticNodeInAssist(nodeData);
        }
    }

    const handleAgenticStart = (data : any) => {
        rootServiceInstance.isAgenticCoPilotEnabled = true;
        setAgenticStartEnabled(true);
    }

    const handleAgenticEnd = (data : any) => {
        rootServiceInstance.isAgenticCoPilotEnabled = false;
        setAgenticStartEnabled(false);
        removeAgenticNodesFromAssist();
    }
    

    const removeAgenticNodesFromAssist = () => {
        hostInstance?.chatEle?.querySelector(`${classConstants.ASSIST_BLOCK_CONTENT}`)?.classList?.remove('highlight-agentic-block-content');
        hostInstance?.chatEle?.querySelector(`${classConstants.AGENTIC_COPILOT_MODE_WRAPPER}`)?.classList?.add('aa-hidden');
        hostInstance?.chatEle?.querySelector(`${classConstants.ASSIST_EMPTY_AGENTIC}`)?.classList?.add(classConstants.HIDE_ELEMENT);
        hostInstance?.chatEle?.querySelectorAll(`${classConstants.AGENTIC_COPILOT_NODE_WRAPPER}`)?.forEach((node : any) => {
            node?.classList?.add(classConstants.HIDE_ELEMENT);
        });
        hostInstance?.chatEle?.querySelector(`${classConstants.ASSIST_TERMINATE_BUTTON}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
        hostInstance?.chatEle?.querySelector(`${classConstants.ASSIST_LISTVIEW_BUTTON}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
        hostInstance?.chatEle?.querySelector(`${classConstants.AGENTIC_PAUSE_AUTO_SEND_BTN}`)?.classList?.add(classConstants.HIDE_ELEMENT);
        hostInstance?.chatEle?.querySelector(`${classConstants.AGENTIC_PAUSE_BTN}`)?.classList?.add(classConstants.HIDE_ELEMENT);
    }

    const handleAgenticResponse = (response : any) => {
        if(response && !response?.isSearch){
            const data = {
                answer: response.response[0]?.content,
                override: response.override,
                send: '',
                isSent: false
            };

            const nodeDataIndex = agenticNodeArray.findIndex((node:any) => node.requestId === response?.requestId);

            if(nodeDataIndex !== -1){
                agenticNodeArray[nodeDataIndex].isThinking = false;
                agenticNodeArray[nodeDataIndex] = { ...agenticNodeArray[nodeDataIndex], ...data };
                setAgenticPilotArr((prev:any) => {
                    const lastIndex = prev.length-1;
                    const updatedArr = [...prev];
                    updatedArr[lastIndex] = {
                        ...updatedArr[lastIndex],
                        ...data
                    }
                    return updatedArr;
                });
                getLastAgenticNode(nodeDataIndex -1);
                addAgenticResponseInNode(nodeDataIndex)
            }else{
                const nodeData = {
                    reqMsg: response.query,
                    answer: response.response[0]?.content,
                    override: response.override,
                    send: '',
                    isSent: false,
                    requestId: response?.requestId,
                    positionId: response?.metadata?.positionId,
                    index: agenticNodeArray.length,
                    author: response?.metadata?.author?.type?.toUpperCase() || 'AGENT',
                }

                setAgenticPilotArr([...agenticPilotArr, nodeData]);
                getLastAgenticNode(nodeDataIndex -1);
                addAgenticNodeInAssist(nodeDataIndex);
                agenticNodeArray.push(nodeData);
            }
        }
    }

    const addAgenticResponseInNode = (nodeDataIndex : any) => {
        let agenticNodeHtml:any = hostInstance?.chatEle?.querySelector(`${classConstants.AGENTIC_NODE_WRAPPER}${nodeDataIndex}`);
        if(agenticNodeHtml){
            agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_INTERRUPT_BODY}${nodeDataIndex}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
            agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_INTERRUPT_OVERRIDE}${nodeDataIndex}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
            agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_THINKING_MSG}${nodeDataIndex}`)?.classList?.add(classConstants.HIDE_ELEMENT);

            const nodeData = agenticNodeArray[nodeDataIndex];

            const answerHtml = marked.parse(nodeData?.answer || '');

            if(hostInstance?.config?.connectionDetails?.channel === 'voice'){
                agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_SEND_OR_COPY_ACTIONS}`)?.classList?.add(classConstants.HIDE_ELEMENT);
            }

            if(rootServiceInstance?.isAgenticPaused && !nodeData?.isThinking){
                addAgenticPauseSection(agenticNodeHtml, nodeDataIndex);
            }

            if(hostInstance?.rootService?.isAgenticAutoSendEnabled && !nodeData?.history){
                if(agenticNodeArray?.length === 1 && !nodeData?.isSent){
                    addDynamicSendActionBtn(agenticNodeHtml, nodeDataIndex);
                }else if(agenticNodeArray?.length > 1 && nodeData?.isSent){
                    addDynamicSendActionBtn(agenticNodeHtml, nodeDataIndex);
                }else if(agenticNodeArray?.length > 1 && !nodeData?.isSent && !rootServiceInstance?.timerForSendingAgenticAutoSend){
                    addDynamicSendActionBtn(agenticNodeHtml, nodeDataIndex);
                }
            }

            if(nodeData?.history && !nodeData?.isEnd){
                agenticNodeHtml.style.opacity = rootServiceInstance?.prefsOpacity/100;
            }

            addEventListenersInSendOrCopyActions(agenticNodeHtml, nodeDataIndex);
            agenticNodeHtml.querySelector(`${classConstants.AGENTIC_NODE_ANSWER}`).innerHTML = answerHtml;
            rootServiceInstance?.handleAssistScroll(hostInstance);
        }
    }

    const addThinkingAgenticNodeInAssist = (nodeData : any) => {

    
        hostInstance?.chatEle?.querySelector(`${classConstants.ASSIST_EMPTY_AGENTIC}`)?.classList?.add(classConstants.HIDE_ELEMENT);

        let agenticNodeWrapperHtml:any = getHTML(agenticCoPilotNodeHeaderSection, {positionId: nodeData?.index, reqMsg: nodeData?.reqMsg, author: nodeData?.author}, hostInstance);
        let agenticNodeThinkingHtml:any = getHTML(agenticCoPilotMessageSection, {positionId: nodeData?.index}, hostInstance);

        agenticNodeWrapperHtml?.querySelector(`${classConstants.AGENTIC_COPILOT_NODE_BODY_WRAPPER}${nodeData?.index}`)?.appendChild(agenticNodeThinkingHtml);

        if(agenticNodeWrapperHtml){
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, agenticNodeWrapperHtml, {
                event: SDK_EVENTS.ACP_AGENTIC_NODE_TEMPLATE,
                data: nodeData
            });   
            hostInstance?.chatEle?.querySelector(`${classConstants.ASSIST_SECTION}`)?.append(agenticNodeWrapperHtml);
            addEventListenersInAgenticNode(agenticNodeWrapperHtml, nodeData?.index);
        }
    }

    const addAgenticNodeInAssist = (nodeDataPosition : number = agenticNodeArray.length-1) => {
        hostInstance?.chatEle?.querySelector(`${classConstants.ASSIST_EMPTY_AGENTIC}`)?.classList?.add(classConstants.HIDE_ELEMENT);
        let agenticNodeWrapperHtml:any = getHTML(agenticCoPilotNodeHeaderSection, {positionId: agenticNodeArray[nodeDataPosition]?.index, reqMsg: agenticNodeArray[nodeDataPosition]?.reqMsg, author: agenticNodeArray[nodeDataPosition]?.author}, hostInstance);
        let agenticNodeThinkingHtml:any = getHTML(agenticCoPilotMessageSection, {positionId: agenticNodeArray[nodeDataPosition]?.index}, hostInstance);

        agenticNodeWrapperHtml?.querySelector(`${classConstants.AGENTIC_COPILOT_NODE_BODY_WRAPPER}${agenticNodeArray[nodeDataPosition]?.index}`)?.appendChild(agenticNodeThinkingHtml);
        
        if(agenticNodeWrapperHtml){
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, agenticNodeWrapperHtml, {
                event: SDK_EVENTS.ACP_AGENTIC_NODE_TEMPLATE,
                data: agenticNodeArray[nodeDataPosition]
            });   

            const answerHtml =  marked.parse(agenticNodeArray[nodeDataPosition]?.answer || '');
            if(hostInstance?.config?.connectionDetails?.channel === 'voice'){
                agenticNodeWrapperHtml.querySelector(`${classConstants.AGENTIC_SEND_OR_COPY_ACTIONS}`)?.classList?.add(classConstants.HIDE_ELEMENT);
            }
            if(hostInstance?.rootService?.isAgenticAutoSendEnabled && !agenticNodeArray[nodeDataPosition]?.history){
                if(agenticNodeArray?.length === 1 && !agenticNodeArray[agenticNodeArray.length-1]?.isSent){
                    addDynamicSendActionBtn(agenticNodeWrapperHtml, agenticNodeArray.length-1);
                }else if(agenticNodeArray?.length > 1 && agenticNodeArray[agenticNodeArray.length-1]?.isSent){
                    addDynamicSendActionBtn(agenticNodeWrapperHtml, agenticNodeArray.length-1);
                }else if(agenticNodeArray?.length > 1 && !agenticNodeArray[agenticNodeArray.length-1]?.isSent && !rootServiceInstance?.timerForSendingAgenticAutoSend){
                    addDynamicSendActionBtn(agenticNodeWrapperHtml, agenticNodeArray.length-1);
                }
            }
            if(agenticNodeArray[nodeDataPosition]?.history && !agenticNodeArray[nodeDataPosition]?.isEnd){
                agenticNodeWrapperHtml.style.opacity = rootServiceInstance?.prefsOpacity/100;
                agenticNodeWrapperHtml.querySelector(`${classConstants.AGENTIC_NODE_ANSWER}`)?.classList?.add('agentic-text-contrast');
            }
            addEventListenersInSendOrCopyActions(agenticNodeWrapperHtml, nodeDataPosition);
            agenticNodeWrapperHtml.querySelector(`${classConstants.AGENTIC_NODE_ANSWER}`).innerHTML = answerHtml;
            agenticNodeWrapperHtml?.querySelector(`${classConstants.AGENTIC_INTERRUPT_BODY}${nodeDataPosition}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
            agenticNodeWrapperHtml?.querySelector(`${classConstants.AGENTIC_INTERRUPT_OVERRIDE}${nodeDataPosition}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
            agenticNodeWrapperHtml?.querySelector(`${classConstants.AGENTIC_THINKING_MSG}${nodeDataPosition}`)?.classList?.add(classConstants.HIDE_ELEMENT);
            addEventListenersInAgenticNode(agenticNodeWrapperHtml, nodeDataPosition);    
            hostInstance?.chatEle?.querySelector(`${classConstants.ASSIST_SECTION}`)?.append(agenticNodeWrapperHtml);
        }
    }


    const addAssistHeader = () => {
        hostInstance?.chatEle?.querySelector(`${classConstants.ASSIST_TERMINATE_BUTTON}`)?.classList?.add(classConstants.HIDE_ELEMENT);
        hostInstance?.chatEle?.querySelector(`${classConstants.ASSIST_LISTVIEW_BUTTON}`)?.classList?.add(classConstants.HIDE_ELEMENT);
        hostInstance?.chatEle?.querySelector(`${classConstants.AGENTIC_PAUSE_AUTO_SEND_BTN}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
        hostInstance?.chatEle?.querySelector(`${classConstants.AGENTIC_PAUSE_BTN}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
        isHeaderAddedRef.current = true;
        addHeaderEventListeners(hostInstance?.chatEle);
    }

    const getCoPilotHistory = async() =>{
        fetchAgenticHistory().then((res:any)=>{
            if(res && res?.length > 0){
                initializeUI();
                hostInstance.rootService.isAgenticCoPilotEnabled = true;
                setCoPilotHistory(res);
            }
        }).catch((err:any)=>{
            hostInstance.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_AGENTIC_COPILOT_HISTORY_API_FAILURE']);
        })

    }

    const setCoPilotHistory = (history:any) =>{
        if(history && history?.length > 0){
            history?.forEach((historyItem:any,index:number)=>{

                if(agenticNodeArray?.find((node:any) => node.requestId === historyItem?.requestId)){
                    return;
                }

                const data = {
                    reqMsg: historyItem?.query,
                    answer: historyItem?.responses?.[0]?.response?.[0]?.content,
                    override: historyItem?.override,
                    send: '',
                    isSent: false,
                    author: historyItem?.override ? 'AGENT' : 'USER',
                    history: true,
                    isEnd: index === history?.length - 1,
                    index: index
                }
                getLastAgenticNode();
                agenticNodeArray.push(data);
                setAgenticPilotArr((prev:any) => [...prev, data]);
                addAgenticNodeInAssist(index)
    
            })
        }
    }


    const fetchAgenticHistory = () =>{
        const { channel,botId, conversationId } = rootServiceInstance.connectionDetails;
        return fetchInstance('copilotMessages', {
            method: 'GET',
            headers: {
            'Content-Type': 'application/json',
            },
        },  hostInstance, { botId,  channel, convId: conversationId, skip: 0, limit: 100, msgDirection: 'asc'});
    }

    const addHeaderEventListeners = (chatEle : any) =>{
        const pauseAutoSendBtn = chatEle?.querySelector(`${classConstants.AGENTIC_PAUSE_AUTO_SEND_BTN}`);
        if(pauseAutoSendBtn){
            hostInstance?.eventManager?.addEventListener(`${classConstants.AGENTIC_PAUSE_AUTO_SEND_BTN}`, 'click', (e:any) => {
                setIsAutoSendEnabled((prev)=>!prev);
                if(rootServiceInstance?.timerForSendingAgenticAutoSend){
                    clearTimeout(rootServiceInstance?.timerForSendingAgenticAutoSend);
                    rootServiceInstance.timerForSendingAgenticAutoSend = null;
                    hostInstance?.chatEle?.querySelectorAll(`${classConstants.AGENTIC_DYNAMIC_SENDING_ACTION_BTN}`)?.forEach((node : any) => {
                        node?.classList?.add(classConstants.HIDE_ELEMENT);
                    });
                    hostInstance?.chatEle?.querySelectorAll(`${classConstants.AGENTIC_SEND_OR_COPY_ACTIONS}`)?.forEach((node : any) => {
                        node?.classList?.remove(classConstants.HIDE_ELEMENT);
                    });
                }
                hostInstance.rootService.isAgenticAutoSendEnabled = !hostInstance.rootService.isAgenticAutoSendEnabled;
            }, chatEle)
        }
        const pauseBtn = chatEle?.querySelector(`${classConstants.AGENTIC_PAUSE_BTN}`);
        if(pauseBtn){
            hostInstance?.eventManager?.addEventListener(`${classConstants.AGENTIC_PAUSE_BTN}`, 'click', (e:any) => {
                setIsPaused((prev)=>!prev);
            }, chatEle)
        }
    }

    const addEventListenersInAgenticNode = (agenticNodeHtml : any, agenticNodePosition : any) =>{
        const overrideSection = agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_INTERRUPT_OVERRIDE}${agenticNodePosition}`);
        const custInfoSection = agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_NODE_CUST_INFO}${agenticNodePosition}`);

        if(overrideSection && !agenticNodeArray[agenticNodePosition]?.isThinking && hostInstance?.rootService?.isAgenticPaused){
            addAgenticPauseSection(agenticNodeHtml, agenticNodePosition);
            return;
        }

        if(custInfoSection){
            hostInstance?.eventManager?.addEventListener(`${classConstants.AGENTIC_NODE_CUST_INFO}${agenticNodePosition}`, 'dblclick', ()=>{
                const nodeBodyWrapper = agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_NODE_BODY_WRAPPER}${agenticNodePosition}`);
                const nodeCustInfo = agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_NODE_CUST_INFO}${agenticNodePosition}`);
                const regenerateInputWrapper = agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_NODE_REGENERATE_INPUT_WRAPPER}${agenticNodePosition}`);

                nodeBodyWrapper?.classList?.add(classConstants.HIDE_ELEMENT);
                nodeCustInfo?.classList?.add(classConstants.HIDE_ELEMENT);

                regenerateInputWrapper?.classList?.remove(classConstants.HIDE_ELEMENT);

                // Only add event listeners if they haven't been added before
                if(!regenerateInputWrapper?.hasAttribute('data-listeners-added')){
                    addEventListenerToRegenerateInput(regenerateInputWrapper, nodeBodyWrapper, nodeCustInfo, agenticNodePosition, agenticNodeHtml);
                    regenerateInputWrapper?.setAttribute('data-listeners-added', 'true');
                }
            }, agenticNodeHtml)
        }
        
        if(overrideSection){
            hostInstance?.eventManager?.addEventListener(`${classConstants.AGENTIC_INTERRUPT_OVERRIDE}${agenticNodePosition}`, 'click', (e:any) => {
                emitAgenticOverrideEvent(false);
                addOverrideInputInAgenticNode(agenticNodeHtml, agenticNodePosition);
            },agenticNodeHtml)
        }
    }

    const addEventListenerToRegenerateInput = (regenerateInputHtml : any, bodyWrapper : any, custInfo : any, agenticNodePosition : number, agenticNodeHtml:any) =>{
        const regenerateInput = regenerateInputHtml?.querySelector(`${classConstants.AGENTIC_NODE_REGENERATE_INPUT}`);
        const regenerateCancel = regenerateInputHtml?.querySelector(`${classConstants.AGENTIC_NODE_REGENERATE_CANCEL_BTN}`);
        const regenerateSubmit = regenerateInputHtml?.querySelector(`${classConstants.AGENTIC_NODE_REGENERATE_SUBMIT_BTN}`)
        if(regenerateInput){
            hostInstance?.eventManager?.addEventListener(`${classConstants.AGENTIC_NODE_REGENERATE_INPUT}`, 'keydown', (e:any) => {
                if(e.key === 'Enter'){
                    regenerateInputHtml?.classList?.add(classConstants.HIDE_ELEMENT);
                    bodyWrapper?.classList?.remove(classConstants.HIDE_ELEMENT);
                    custInfo?.classList?.remove(classConstants.HIDE_ELEMENT);
                    emitAgenticRequest(true, e.target.value);
                    regenerateInputHtml.querySelector(`${classConstants.AGENTIC_NODE_REGENERATE_INPUT}`).value = agenticNodeArray[agenticNodePosition]?.reqMsg || '';
                }
            }, agenticNodeHtml)
        }

        if(regenerateCancel){
            hostInstance?.eventManager?.addEventListener(`${classConstants.AGENTIC_NODE_REGENERATE_CANCEL_BTN}`,'click',(e:any)=>{
                regenerateInputHtml?.classList?.add(classConstants.HIDE_ELEMENT);
                bodyWrapper?.classList?.remove(classConstants.HIDE_ELEMENT);
                custInfo?.classList?.remove(classConstants.HIDE_ELEMENT);
                regenerateInputHtml.querySelector(`${classConstants.AGENTIC_NODE_REGENERATE_INPUT}`).value = agenticNodeArray[agenticNodePosition]?.reqMsg || '';
            }, agenticNodeHtml)
        }

        if(regenerateSubmit){
            hostInstance?.eventManager?.addEventListener(`${classConstants.AGENTIC_NODE_REGENERATE_SUBMIT_BTN}`,'click',(e:any)=>{
                regenerateInputHtml?.classList?.add(classConstants.HIDE_ELEMENT);
                bodyWrapper?.classList?.remove(classConstants.HIDE_ELEMENT);
                custInfo?.classList?.remove(classConstants.HIDE_ELEMENT);
                emitAgenticRequest(true, regenerateInput?.value);
                regenerateInputHtml.querySelector(`${classConstants.AGENTIC_NODE_REGENERATE_INPUT}`).value = agenticNodeArray[agenticNodePosition]?.reqMsg || '';
            }, agenticNodeHtml)
        }
    }

    const getLastAgenticNode = (index : number = agenticNodeArray.length-1) => {
        if(agenticNodeArray.length > 0 && index >= 0){
            hostInstance?.chatEle?.querySelector(`${classConstants.AGENTIC_INTERRUPT_OVERRIDE}${index}`)?.classList?.add(classConstants.HIDE_ELEMENT);
        }
    }

    const addEventListenersInSendOrCopyActions = (agenticNodeHtml : any, agenticNodePosition : any) =>{
        const sendButton = agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_SENT_BTN}`);
        const copyButton = agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_COPY_BTN}`);
        if(sendButton){
            hostInstance?.eventManager?.addEventListener(`${classConstants.AGENTIC_SENT_BTN}`, 'click', (e:any) => {

                if(agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_DYNAMIC_SEND_ACTION_BTN_TEXT}`)){
                    agenticNodeHtml.querySelector(`${classConstants.AGENTIC_DYNAMIC_SEND_ACTION_BTN_TEXT}`).innerHTML = 'Sent';
                }

                agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_NODE_ANSWER}`)?.classList?.add('agentic-text-contrast');
                agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_SENT_COPY_ACTION}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
                agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_SENT_COPY_ACTION}`)?.classList?.add('aa-sent-text');
                agenticNodeHtml.querySelector(`${classConstants.AGENTIC_SENT_COPY_ACTION}`).innerHTML = 'Sent';
                emitSendOrCopyEvent(ProjConstants.SEND, agenticNodeHtml, agenticNodePosition);
            }, agenticNodeHtml)
        }
        if(copyButton){
            hostInstance?.eventManager?.addEventListener(`${classConstants.AGENTIC_COPY_BTN}`, 'click', (e:any) => {

                if(agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_DYNAMIC_SEND_ACTION_BTN_TEXT}`)){
                    agenticNodeHtml.querySelector(`${classConstants.AGENTIC_DYNAMIC_SEND_ACTION_BTN_TEXT}`).innerHTML = 'Copied';
                }

                agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_NODE_ANSWER}`)?.classList?.add('agentic-text-contrast');
                agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_SENT_COPY_ACTION}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
                agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_SENT_COPY_ACTION}`)?.classList?.add('aa-sent-text');
                agenticNodeHtml.querySelector(`${classConstants.AGENTIC_SENT_COPY_ACTION}`).innerHTML = 'Copied';
                emitSendOrCopyEvent(ProjConstants.COPY, agenticNodeHtml, agenticNodePosition);
            }, agenticNodeHtml)
        }   
    }

    const addOverrideInputInAgenticNode = (agenticNodeHtml : any, agenticNodePosition : any) =>{
        
        if(agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_NODE_OVERRIDE_INPUT_WRAPPER}${agenticNodePosition}`)){
            agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_NODE_OVERRIDE_INPUT_WRAPPER}${agenticNodePosition}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
            agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_INTERRUPT_OVERRIDE}${agenticNodePosition}`)?.classList?.add(classConstants.HIDE_ELEMENT);
            return;
        }
        
        let overrideInputHtml = getHTML(RenderAgenticOverrideInput, {author: agenticNodeArray[agenticNodePosition]?.author, positionId: agenticNodePosition}, hostInstance);
        if(overrideInputHtml){
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, overrideInputHtml, {
                event: SDK_EVENTS.ACP_AGENTIC_OVERRIDE_INPUT_TEMPLATE
            });

            agenticNodeHtml.querySelector(`${classConstants.AGENTIC_INTERRUPT_OVERRIDE}${agenticNodePosition}`)?.classList?.add(classConstants.HIDE_ELEMENT);
            agenticNodeHtml.append(overrideInputHtml);
            addEventListenersInOverrideInput(overrideInputHtml, agenticNodeHtml, agenticNodePosition);
        }
        
    }

    const addAgenticPauseSection = (agenticNodeHtml : any, agenticNodePosition : any) =>{
        agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_INTERRUPT_OVERRIDE}${agenticNodePosition}`)?.classList?.add(classConstants.HIDE_ELEMENT);
        let overrideInputHtml = getHTML(RenderAgenticOverrideInput, {author: agenticNodeArray[agenticNodePosition]?.author, positionId: agenticNodePosition}, hostInstance);
        if(overrideInputHtml){
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, overrideInputHtml, {
                event: SDK_EVENTS.ACP_AGENTIC_OVERRIDE_INPUT_TEMPLATE
            });
            agenticNodeHtml.append(overrideInputHtml);
            addEventListenersInOverrideInput(overrideInputHtml, agenticNodeHtml, agenticNodePosition);
        }
        
    }

    const addEventListenersInOverrideInput = (overrideInputHtml : any, agenticNodeHtml : any, agenticNodePosition : any) =>{
        const cancelButton = overrideInputHtml?.querySelector(`${classConstants.AGENTIC_INPUT_OVERRIDE_CANCEL_BTN}`);
        const submitButton = overrideInputHtml?.querySelector(`${classConstants.AGENTIC_INPUT_OVERRIDE_SUBMIT_BTN}`);

        
        hostInstance?.eventManager?.addEventListener(`${classConstants.AGENTIC_OVERRIDE_TEXT}`, 'keydown', (e:any) => {
            if(e.key === 'Enter'){
                emitAgenticOverrideEvent(true);
                if(hostInstance?.rootService?.isAgenticPaused){
                    agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_NODE_OVERRIDE_INPUT_WRAPPER}${agenticNodePosition}`)?.classList?.add(classConstants.HIDE_ELEMENT);
                }
                const OverrideText = agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_OVERRIDE_TEXT}`)?.value;
                emitAgenticRequest(false, OverrideText)
                overrideInputHtml?.classList?.add(classConstants.HIDE_ELEMENT)
            }
        }, overrideInputHtml)

        if(cancelButton){
            hostInstance?.eventManager?.addEventListener(`${classConstants.AGENTIC_INPUT_OVERRIDE_CANCEL_BTN}`, 'click', (e:any) => {
                if(hostInstance?.rootService?.isAgenticPaused){
                    agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_NODE_OVERRIDE_INPUT_WRAPPER}${agenticNodePosition}`)?.classList?.add(classConstants.HIDE_ELEMENT);
                }
                overrideInputHtml?.classList?.add(classConstants.HIDE_ELEMENT);
                agenticNodeHtml.querySelector(`${classConstants.AGENTIC_INTERRUPT_OVERRIDE}${agenticNodePosition}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
                emitAgenticOverrideEvent(true);
            }, overrideInputHtml)
        }
        if(submitButton){
            hostInstance?.eventManager?.addEventListener(`${classConstants.AGENTIC_INPUT_OVERRIDE_SUBMIT_BTN}`, 'click', (e:any) => {
                emitAgenticOverrideEvent(true);
                if(hostInstance?.rootService?.isAgenticPaused){
                    agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_NODE_OVERRIDE_INPUT_WRAPPER}${agenticNodePosition}`)?.classList?.add(classConstants.HIDE_ELEMENT);
                }
                const OverrideText = agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_OVERRIDE_TEXT}`)?.value;
                emitAgenticRequest(false, OverrideText);
                overrideInputHtml?.classList?.add(classConstants.HIDE_ELEMENT)

            }, overrideInputHtml)
        }

    }

    const emitAgenticOverrideEvent = (isCancel : boolean) =>{
        if(!isPaused){
            hostInstance?.socketConnection?.emitEvents(EVENTS.agentic_override, {
                    override: isCancel ? false : true
            });
        }
    }

    const emitAgenticRequest = (isRegenerate : boolean = false, OverrideText : string) =>{
        if(!isRegenerate){
            hostInstance?.socketConnection?.emitEvents(EVENTS.agentic_request, {
                    isSearch:false,
                    override:true,
                    query: OverrideText,
                    botId: hostInstance?.config?.connectionDetails?.botId
                });
        }
        else{
            hostInstance?.socketConnection?.emitEvents(EVENTS.agentic_request, {
                isSearch:false,
                override:true,
                query: OverrideText,
                botId: hostInstance?.config?.connectionDetails?.botId
            });
        }
    }

    const emitSendOrCopyEvent = (type : string, agenticNodeHtml : any, agenticNodePosition : any) =>{
        const copyEventData = prepareSendOrCopyEventData(type, agenticNodeHtml, agenticNodePosition);
        const agenticUpdateData = prepareAgenticUpdateData(type, agenticNodeHtml, agenticNodePosition);
        hostInstance?.socketConnection?.emitEvents(EVENTS.agent_send_or_copy, copyEventData);
        hostInstance?.socketConnection?.emitEvents(EVENTS.update_agentic_response, agenticUpdateData);
        const agentData = prepareAgentData(type,agenticNodeHtml, agenticNodePosition);
        hostInstance?.sendAgentMessage(agentData);
        if(type === ProjConstants.SEND){
            agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_SENT_TEXT}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
            agenticNodeHtml.style.opacity = rootServiceInstance?.prefsOpacity/100;
        }
        else{
            agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_COPY_TEXT}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
            agenticNodeHtml.style.opacity = rootServiceInstance?.prefsOpacity/100;
        }
    }

    const prepareAgenticUpdateData = (type : string, agenticNodeHtml : any, agenticNodePosition : any) =>{
        let positionId = RandomuuidPipe('positionId')
        const agenticUpdateData = {
            positionId: positionId,
            usedType: type,
            name : type === ProjConstants.SEND ? ProjConstants.SENDMSG : ProjConstants.COPYMSG,
            payload : agenticNodeArray[agenticNodePosition]?.answer,
            type:'sentence',
            sessionId: hostInstance?.rootService?.getSessionId(),
            skipMsg: false,
            isAgentic: true,
            botId: hostInstance?.config?.connectionDetails?.botId,
            isSent: type === ProjConstants.SEND ? true : false,
            requestId: agenticNodeArray[agenticNodePosition]?.requestId
        }
        return agenticUpdateData;
    }

    const prepareSendOrCopyEventData = (type : string, agenticNodeHtml : any, agenticNodePosition : any) =>{
        const copyEventData = {
            usedType: type,
            name : type === ProjConstants.SEND ? ProjConstants.SENDMSG : ProjConstants.COPYMSG,
            payload : agenticNodeArray[agenticNodePosition]?.answer,
        }
        return copyEventData;
    }

    const prepareAgentData = (type : string, agenticNodeHtml : any, agenticNodePosition : any) =>{
        const agentData = {
            author: {
                id: "authorids",
                type: 'AGENT',
                firstName: "first name",
                lastName: "last name"
            },
            message: agenticNodeArray[agenticNodePosition]?.answer,
            type: 'AGENT',
        }
        return agentData;
    }

    const addDynamicSendActionBtn = (agenticNodeHtml : any, agenticNodePosition : any) =>{
        const dynamicSendActionBtnHtml = getHTML(DynamicSendActionBtn, { isSending: true, timeOut : rootServiceInstance.sendingTimeForAgenticAutoSend }, hostInstance);
        if(dynamicSendActionBtnHtml){
            hostInstance.emit(SDK_EVENTS.BEFORE_VIEW_INIT, dynamicSendActionBtnHtml, {
                event: SDK_EVENTS.ACP_AGENTIC_DYNAMIC_SEND_ACTION_BTN_TEMPLATE
            });
            agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_SEND_DYN_BTN}`)?.append(dynamicSendActionBtnHtml);
            
            const buttonElement = dynamicSendActionBtnHtml as HTMLElement;
            const progressCleanupRef: { current: (() => void) | null } = { current: null };
            
            if (buttonElement && rootServiceInstance.sendingTimeForAgenticAutoSend) {
                setTimeout(() => {
                    progressCleanupRef.current = initializeProgressOnButton(buttonElement, rootServiceInstance.sendingTimeForAgenticAutoSend,hostInstance);
                }, 0);
            }
            
            addEventListenersInDynamicSendActionBtn(dynamicSendActionBtnHtml, agenticNodeHtml, agenticNodePosition, progressCleanupRef);
        }
    }

    const addEventListenersInDynamicSendActionBtn = (dynamicSendActionBtnHtml : any, agenticNodeHtml : any, agenticNodePosition : any, progressCleanupRef: { current: (() => void) | null }) =>{
        agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_SEND_OR_COPY_ACTIONS}`)?.classList?.add(classConstants.HIDE_ELEMENT);

        rootServiceInstance.timerForSendingAgenticAutoSend = setTimeout(()=>{
        
            dynamicSendActionBtnHtml?.querySelector(`${classConstants.AGENTIC_DYNAMIC_SEND_CLOSE_BTN}`).classList.add(classConstants.HIDE_ELEMENT);
            dynamicSendActionBtnHtml?.querySelector(`${classConstants.AGENTIC_DYNAMIC_SEND_ACTION_BTN_TEXT}`)?.classList?.add(`aa-sent-text`);
            agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_SEND_OR_COPY_ACTIONS}`)?.classList?.remove(classConstants.HIDE_ELEMENT);

            agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_NODE_ANSWER}`)?.classList?.add('agentic-text-contrast');
            
            agenticNodeArray[agenticNodePosition].isSent = true;
            rootServiceInstance.timerForSendingAgenticAutoSend = null;
            handleTimerForNextSend(agenticNodePosition+1);
            if (progressCleanupRef.current) {
                progressCleanupRef.current();
                progressCleanupRef.current = null;
            }
            emitSendOrCopyEvent(ProjConstants.SEND, agenticNodeHtml, agenticNodePosition);
        }, rootServiceInstance.sendingTimeForAgenticAutoSend);
        
        hostInstance?.eventManager?.addEventListener(`${classConstants.AGENTIC_DYNAMIC_SEND_CLOSE_BTN}`, 'click', (e:any) => {
            clearTimeout(rootServiceInstance?.timerForSendingAgenticAutoSend);
            rootServiceInstance.timerForSendingAgenticAutoSend = null;
            if (progressCleanupRef.current) {
                progressCleanupRef.current();
                progressCleanupRef.current = null;
            }
            agenticNodeHtml?.querySelector(`${classConstants.AGENTIC_SEND_OR_COPY_ACTIONS}`)?.classList?.remove(classConstants.HIDE_ELEMENT);
            handleTimerForNextSend(agenticNodePosition+1, true);
            dynamicSendActionBtnHtml?.classList?.add(classConstants.HIDE_ELEMENT);

        }, dynamicSendActionBtnHtml)
    }

    const handleTimerForNextSend = (agenticNodePosition : any, isCancel : boolean = false) =>{
        const agenticNodeHtml = hostInstance?.chatEle?.querySelector(`${classConstants.AGENTIC_NODE_WRAPPER}${agenticNodePosition}`);
        if(agenticNodeHtml && !isCancel && rootServiceInstance?.isAgenticAutoSendEnabled && agenticNodeArray[agenticNodePosition-1]?.isSent && !agenticNodeArray[agenticNodePosition-1]?.history){
            addDynamicSendActionBtn(agenticNodeHtml, agenticNodePosition);
        }

        if(isCancel && agenticNodeHtml && rootServiceInstance?.isAgenticAutoSendEnabled && !agenticNodeArray[agenticNodePosition-1]?.history){
            addDynamicSendActionBtn(agenticNodeHtml, agenticNodePosition);
        }
    }

    const emitAgenticPauseEvent = () =>{
        if(isPaused){
            hostInstance?.socketConnection?.emitEvents(EVENTS.agentic_pause, {
                state: 'pause'
            });
        }
        else{
            hostInstance?.socketConnection?.emitEvents(EVENTS.agentic_resume, {
                state: 'resume'
            })
        }
    }

    

    return (
        <Fragment>

        </Fragment>
    )
}